import hydrate from '../common/hydrate';
import HeadingsSection from './components/HeadingsSection';
import { root, name } from './manifest.json';
hydrate(HeadingsSection, root, name);
if (module.hot) {
    module.hot.accept();
}
